"use client";

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "@/components/ui/dialog";
import {Button} from "@/components/ui/button";

export default function CWFDialog({ children, trigger, title,modalLarge, className,description, ...props }) {
    console.log("Is large  : ", modalLarge);
    return (
        <Dialog {...props} modalLarge={modalLarge}>
            {trigger !== null && (
                <DialogTrigger asChild>
                    {trigger ?? (
                        <Button>Dialog</Button>
                    )}
                </DialogTrigger>
            )}

            <DialogContent className={className}>
                <DialogHeader>
                    {title && <DialogTitle>{title}</DialogTitle>}
                    {description && <DialogDescription>{description}</DialogDescription>}
                </DialogHeader>
                {children}
            </DialogContent>
        </Dialog>
    );
}